var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":"https://myauroraagent.com/","target":"_blank","aria-describedby":"new-window-warning","rel":"noopener noreferrer"}},[_vm._t("default",function(){return [_vm._v("example Enhanced Microsite")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }